import React from 'react';
import SearchBox from 'components/common/SearchBox';
import { ReactComponent as ChevronDown } from '../../assets/img/chevron-down.svg';
import * as Popover from '@radix-ui/react-popover';

export default function InputSelectState({
  children: _children,
  activeState = null,
  disabled = false,
  searchQuery,
  searchResults,
  setSearchQuery,
  isSearchResultsLoading,
  updateSelected,
  color = null,
  selected: _s,
}) {
  return (
    <Popover.Root>
      <div
        data-component-name='InputSelectState'
        className={`rounded-md border group relative ${
          disabled === true
            ? 'bg-white-400/0 border-blue-200'
            : 'border-blue-100 bg-white-400'
        }`}
      >
        {disabled === false && (
          <Popover.Portal>
            <Popover.Content
              sideOffset={-56}
              align='end'
              alignOffset={-1}
              className='-top-full w-[340px] border-blue-100 rounded-md z-10 overflow-hidden shadow-md'
            >
              <SearchBox
                searchQuery={searchQuery}
                searchResults={searchResults}
                setSearchQuery={setSearchQuery}
                isSearchResultsLoading={isSearchResultsLoading}
                updateSelected={updateSelected}
                selected={activeState}
                clearButtonClasses='pointer-events-none group-focus-within:pointer-events-auto'
              />
            </Popover.Content>
          </Popover.Portal>
        )}

        <Popover.Trigger asChild>
          <div className=' h-[55px] px-3 flex items-center relative group-hover:shadow-md gap-1.5'>
            {color !== null && (
              <div
                className={`${color === 'green' ? 'bg-green-600' : ''} ${
                  color === 'pink' ? 'bg-pink-600' : ''
                } w-1 h-7  rounded-full min-w-[4px] translate-y-0.5 -ml-0.5`}
              ></div>
            )}
            <div
              className={`flex flex-col w-full mt-1 ${color !== null ? 'pr-1.5' : ''}`}
            >
              {activeState === null && disabled === true && (
                <span className='block text-sm font-semibold text-blue-300'>
                  Loading...
                </span>
              )}
              {activeState === null && disabled === false && (
                <span className='text-blue-300 text-base block leading-4 pr-4 -mt-0.5'>
                  Select state
                </span>
              )}
              <span className='text-blue-500 text-sm font-semibold block -translate-y-0.5'>
                {activeState?.statename}
              </span>
            </div>

            {disabled === false && (
              <div className='absolute right-2.5 text-blue-100 h-full flex items-center pt-0.5'>
                <ChevronDown />
              </div>
            )}
          </div>
        </Popover.Trigger>
      </div>
    </Popover.Root>
  );
}
